import { render, staticRenderFns } from "./gdzie-kupic-chinskie-akcje.md?vue&type=template&id=7445fb00&"
var script = {}


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports